import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-32 text-center">
      <div className="font-mono text-[10rem] leading-none text-[#3B82F6] tracking-tight" style={{ textShadow: "0 0 40px rgba(59,130,246,0.4)" }}>
        404
      </div>
      <div className="font-mono text-xs uppercase tracking-[0.2em] text-[#64748B] mt-4">// Page not found</div>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="mt-10 inline-block px-6 py-3 bg-[#3B82F6] text-black font-mono text-xs uppercase tracking-[0.2em] font-bold hover:bg-[#60A5FA]"
      >
        Home
      </Link>
    </div>
  );
}
